import store from "../store";

export default function isPermitted(permissions) {
    if (!permissions) return true;
    const state = store.getState();
    const role = state.authR.user.role;
    const permissions_array = permissions.toUpperCase().split(",").map(role => role.trim());
    return permissions_array.includes(role.toUpperCase());
}